var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hamburger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14h24v-1.333h-24v1.333zM4 19.333h24v-1.333h-24v1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.276 16.276l6.533 6.533 0.943-0.943-6.533-6.533 5.59-5.59-0.943-0.943-5.59 5.59-5.724-5.724-0.943 0.943 5.724 5.724-6.667 6.667 0.943 0.943 6.667-6.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 15.667c0 0.368-0.299 0.667-0.667 0.667h-20.194c0.873 0.466 1.799 1.006 2.665 1.624 1.794 1.282 3.476 3 3.853 5.266 0.061 0.363-0.185 0.707-0.548 0.767s-0.707-0.185-0.767-0.548c-0.289-1.734-1.608-3.182-3.313-4.4-1.447-1.034-3.069-1.831-4.36-2.466-0.222-0.109-0.434-0.214-0.634-0.314-0.226-0.113-0.369-0.344-0.369-0.596s0.143-0.483 0.369-0.596c0.2-0.1 0.412-0.204 0.634-0.314 1.291-0.635 2.913-1.433 4.36-2.466 1.706-1.218 3.024-2.667 3.313-4.4 0.061-0.363 0.404-0.609 0.767-0.548s0.609 0.404 0.548 0.767c-0.378 2.266-2.059 3.984-3.853 5.266-0.866 0.619-1.792 1.158-2.665 1.624h20.194c0.368 0 0.667 0.299 0.667 0.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hamburger",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 14h24v-1.333h-24v1.333zM4 19.333h24v-1.333h-24v1.333z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.276 16.276l6.533 6.533 0.943-0.943-6.533-6.533 5.59-5.59-0.943-0.943-5.59 5.59-5.724-5.724-0.943 0.943 5.724 5.724-6.667 6.667 0.943 0.943 6.667-6.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-up",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.437l-6.6 6.6-1.885-1.885 8.485-8.485 8.485 8.485-1.885 1.885-6.6-6.6z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pin",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.485 23.152l-8.485 8.485-8.485-8.485c-4.686-4.686-4.686-12.284 0-16.971s12.284-4.686 16.971 0c4.686 4.686 4.686 12.284 0 16.971zM16 17.333c1.473 0 2.667-1.194 2.667-2.667s-1.194-2.667-2.667-2.667-2.667 1.194-2.667 2.667c0 1.473 1.194 2.667 2.667 2.667z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse",
    viewBox: "0 0 26 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.353 15.762c0 8.965-4.997 16.468-13.415 16.233-9.206-0.706-15.248-7.293-12.092-16.938 3.002-9.175 7.576-15.056 14.986-15.056s10.522 6.797 10.522 15.762z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ellipse_number",
    viewBox: "0 0 27 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.576 15.762c0 8.965-5.039 16.468-13.529 16.233-9.284-0.706-15.377-7.293-12.194-16.938 3.028-9.175 7.641-15.056 15.113-15.056s10.611 6.797 10.611 15.762z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.465d51a1f151f010e395dde934926efc.svg";
export { ForwardRef as ReactComponent };